<cv-loader [size]="'medium'" [overlay]="true" *ngIf="loading"></cv-loader>
<sol-modal #modal class="cxone-modal" [title]="headerTitle" [allowClose]="allowClose"
    [primaryButtonLabel]="saveLabel" [basicButtonLabel]="cancelLabel"
    (dismissed)="onDismiss()" (closed)="onSave()">
    <div [formGroup]="formDataBinding">
        <sol-text-area formControlName="notes" #notesTextArea [placeholder]="modalPlaceholder"
        [maxlength]="200"
        (keyup)="formDataBinding.controls['notes'].setValue($event.target['value'].trimStart());noteValue = $event.target['value'].trimStart()"
        (change)="noteValue = $event.target['value'].trimStart()" id="text-area-2">
        </sol-text-area>
    </div>
</sol-modal>